import { Todos as TodosComponent } from '../dashboard/todos'

function Todos () {
  return (
    <div
      className='wrapper'
      style={{ width: '100%', boxSizing: 'border-box' }}
    >
      <div className='dashboard'>
        <div
          className='row'
          style={{ marginTop: '45px' }}
        >
          <div className='col-xs-12 col-sm-12 col-md-12'>
            <TodosComponent
              scope='mine'
              showFilter
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Todos
